// extracted by mini-css-extract-plugin
export default {"modal-link":"Gy6FR","modalLink":"Gy6FR"};